import { render, staticRenderFns } from "./Typeform.vue?vue&type=template&id=38818148&"
import script from "./Typeform.vue?vue&type=script&lang=ts&"
export * from "./Typeform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports